import React from 'react';

import { observer } from 'mobx-react';

import classes from './OrderDetailsBlock.module.scss';
import { HeaderLogo } from '../../../../shared/components/header-components/HeaderLogo/HeaderLogo';
import { PriceInfo } from './PriceInfo/PriceInfo';
import { DetailsTable } from '../../../components/checkout/DetailsTable/DetailsTable';
import { Footer } from '../../../components/checkout/Footer/Footer';
import { challengeCheckoutStore } from '../../../stores/challengeCheckoutStore';
import { SOLUTION_TYPE } from '../../../../shared/constants/user-info/solutionType';

const OrderDetailsBlock = observer(() => {
  const { challengeCheckoutInfo } = challengeCheckoutStore;

  if (!challengeCheckoutInfo) {
    return null;
  }

  const { challenge, checkoutDetails, tax } = challengeCheckoutInfo;

  return (
    <div className={classes.container}>
      <div>
        <div className={classes.logoWrapper}>
          <HeaderLogo solution={SOLUTION_TYPE.CHALLENGE} />
        </div>
        <div className={classes.content}>
          <PriceInfo />
          <DetailsTable
            targetName={challenge.challengeName}
            totalAmount={checkoutDetails.totalAmount}
            taxAmount={checkoutDetails.taxAmount}
            price={challenge.priceFinal}
            tax={tax}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
});

export { OrderDetailsBlock };
